import { Store } from './createStore';
import { StoreContext } from './StoreContext';

export type StoreProviderProps = React.PropsWithChildren<{
  store: Store;
}>;

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, store }) => {
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};
